// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"25c71ac6","88":"e518d86c","142":"4057def8","521":"d37bf818","894":"3333c17f","902":"9d04f02e"}[chunkId] + ".chunk.css";
};